<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Social">Social Safeguard</a></li>
                                <li class="breadcrumb-item active">Pengaturan Social Safeguard</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" style="cursor: pointer;"
                                    data-card-widget="collapse">
                                    <h3 class="card-title">Data Informasi Kegiatan</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12 float-left">
                                            <label>Kode Register<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="register" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedregister" @update:modelValue="onregisterChange"
                                                style="background-color: #ffffff;display: none;"></v-select>
                                            <v-select multiple :options="register" :reduce="(label) => label.code"
                                                label="label" @option:selected="onregisterChangeSelect($event)"
                                                @option:deselected="onregisterChangeDeselect($event)"
                                                v-model="arraynamaregister" id="registerku"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>PIU <small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Nama Kegiatan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm"
                                                    id="Nama_Kegiatan" name="Nama_Kegiatan" placeholder="Nama Kegiatan"
                                                    v-model="Nama_Kegiatan" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Kode Kegiatan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="kode"
                                                    name="kode" placeholder="Kode Kegiatan" v-model="kode" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Lokasi<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Komponen / Output<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="Komponen" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedKomponen" @update:modelValue="onKomponenChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Sub Komponen<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="SubKomponen" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedSubKomponen"
                                                @update:modelValue="onSubKomponenChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Jenis Pekerjaan <small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="jenispekerjaan" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedjenispekerjaan"
                                                @update:modelValue="onjenispekerjaanChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Urutan Kegiatan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="number" class="form-control form-control-sm" id="urut"
                                                    name="urut" placeholder="Urutan Kegiatan" v-model="urut" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="card cardputih">
                                <div class="card-header border-transparent" style="cursor: pointer;"
                                    data-card-widget="collapse">
                                    <h3 class="card-title">Form Input Socia Safeguard</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata" style="font-size: 11px;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 350px;">Parameter</th>
                                                            <th style="width: 100px;">Isian Data</th>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datalist, urutlist) in tahapanpekerjaan"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td :class="datalist.class">
                                                                    {{ datalist.nama }}
                                                                </td>
                                                                <td :class="datalist.class"
                                                                    v-if="datalist.jenis == 'Folder'">
                                                                </td>
                                                                <td :class="datalist.class"
                                                                    v-else-if="datalist.jenis == 'Pilihan'">
                                                                    <select
                                                                        class="form-control form-control-sm custom-select"
                                                                        @change="cekisi('select' + datalist.id)"
                                                                        :id="'select' + datalist.id">
                                                                        <template
                                                                            v-for="(datapilihannya, urutpilihannya) in datalist.pilihannya"
                                                                            :key="urutpilihannya">
                                                                            <option :value="datapilihannya.id"
                                                                                :selected="datapilihannya.id == datalist.isian">
                                                                                {{ datapilihannya.nama }}
                                                                            </option>
                                                                        </template>
                                                                    </select>
                                                                </td>
                                                                <td :class="datalist.class"
                                                                    v-else-if="datalist.jenis == 'Number' || datalist.jenis == 'Double'">
                                                                    <input type="number"
                                                                        :id="datalist.jenis + datalist.id"
                                                                        :name="datalist.jenis + datalist.id"
                                                                        :value="datalist.isian"
                                                                        class="form-control form-control-sm">
                                                                </td>
                                                                <td :class="datalist.class" v-else>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="card cardputih">
                                <div class="card-header border-transparent" style="cursor: pointer;"
                                    data-card-widget="collapse">
                                    <h3 class="card-title">Opsi</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="(secretencData == 'Tambah' && leveluser != 9)"
                                        data-toggle="tooltip" data-placement="left" title="Simpan data.."><i
                                            class="fas fa-plus-square"></i>
                                        Simpan
                                    </button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah' && leveluser != 9)" @click="update()"
                                        data-toggle="tooltip" data-placement="left" title="Update data.."><i
                                            class="fa fa-check-circle"></i>
                                        Update
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.." v-if="leveluser != 9">
                                        <i class="fas fa-window-close"></i> Batal
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.." v-if="leveluser == 9">
                                        <i class="fas fa-fast-backward"></i> Kembali
                                    </button>
                                </div>
                                <div class="card-footer p-3">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">&nbsp;</div>
                        <div class="col-sm-12">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Komponen: [],
            dataKomponen: [],
            defaultSelectedKomponen: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedKomponen: '',
            selectedKomponenlabel: '',

            SubKomponen: [],
            dataSubKomponen: [],
            defaultSelectedSubKomponen: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedSubKomponen: '',
            selectedSubKomponenlabel: '',

            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: 0,

            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedjenispekerjaan: 0,
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi: '',

            register: [],
            dataregister: [],
            defaultSelectedregister: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedregister: '',
            urut: '',
            kode: '',
            validasi: false,
            paramselectedregister: [],
            arraynamaregister: [],
            tahapanpekerjaan: [],
            project_id: process.env.VUE_APP_PROJECT_ID,
        }
    },
    methods: {
        cekisi(isinya) {
            //alert(document.getElementById(isinya).value);
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        onregisterChangeSelect(events) {
            this.paramselectedregister = [];
            for (let i = 0; i < events.length; i++) {
                try {
                    this.paramselectedregister.push((events[i].tag));
                } catch (error) {

                }
            }
            //alert(JSON.stringify(this.paramselectedregister));
        },
        onregisterChangeDeselect(events) {
            //alert(JSON.stringify(events));
            var temp = [];
            temp.push(events);
            //alert(JSON.stringify(temp));
            var yghilang = '';
            for (let i = 0; i < temp.length; i++) {
                try {
                    yghilang = (temp[i].tag);
                } catch (error) {

                }
            }

            var temparray = [];
            for (let i = 0; i < this.paramselectedregister.length; i++) {
                //alert(this.paramselectedregister[i])
                //alert('Hilang '+(yghilang))
                if (this.paramselectedregister[i] !== yghilang) {
                    try {
                        temparray.push(this.paramselectedregister[i]);
                    } catch (error) {

                    }
                }
            }
            this.paramselectedregister = temparray;
            //alert(JSON.stringify(this.paramselectedregister));
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },
        onKomponenChange(a) {
            try {
                this.selectedKomponen = this.Komponen[a].tag;
                this.selectedKomponenlabel = this.Komponen[a].label;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedKomponen);
            this.getsubkomponen();
        },
        onSubKomponenChange(a) {
            try {
                this.selectedSubKomponen = this.SubKomponen[a].tag;
                this.selectedSubKomponenlabel = this.SubKomponen[a].label;
            }
            catch (err) {
                return;
            }
        },
        async getsubkomponen() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedKomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.dataSubKomponen = Response.data.content.data;
                        this.dataSubKomponen.forEach((item) => {
                            this.SubKomponen.push({
                                label: item.nama,
                                code: this.dataSubKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onjenispekerjaanChange(a) {
            try {
                this.selectedjenispekerjaan = this.jenispekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan);
        },
        onregisterChange(a) {
            try {
                this.selectedregister = this.register[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
        },
        ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            mainAPI5.get("parastapainnovation_userproject-GetALLPIU?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.kodesatker,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            mainAPI5.get("parastapainnovation_jenispekerjaan-GetJenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan = [];
                        this.jenispekerjaan = [];
                        this.datajenispekerjaan = Response.data.content.data;
                        this.datajenispekerjaan.forEach((item) => {
                            this.jenispekerjaan.push({
                                label: item.nama,
                                code: this.datajenispekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenispekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            mainAPI5.get("parastapainnovation_lokasi-KotaProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            mainAPI5.get("parastapainnovation_koderegister-GetKodeRegister?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataregister = [];
                        this.register = [];
                        this.dataregister = Response.data.content.data;
                        this.dataregister.forEach((item) => {
                            this.register.push({
                                label: item.kode_register_lengkap,
                                code: this.dataregister.indexOf(item) + 1,
                                tag: item.kode_register,
                            });
                        });
                        this.register.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            const mainAPI6 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            mainAPI6.get("parastapainnovationKomponen-GetProyekKomponen?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataKomponen = [];
                        this.Komponen = [];
                        this.dataKomponen = Response.data.content.data;
                        this.dataKomponen.forEach((item) => {
                            this.Komponen.push({
                                label: item.nama,
                                code: this.dataKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.Komponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            mainAPI6.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedKomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.dataSubKomponen = Response.data.content.data;
                        this.dataSubKomponen.forEach((item) => {
                            this.SubKomponen.push({
                                label: item.nama,
                                code: this.dataSubKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });

                    }
                    else {
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/Social");
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationimg-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationimg-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';
                    this.pic = '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            var random = Math.random();
            mainAPIDataSingel.get("parastapainnovation_social-GetByID?id=" + this.secretencData + "&random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;

                    var id_userpmis = Response.data.content.data[0].id_user;
                    if (id_userpmis != '') {
                        this.defaultSelectedid_user = {
                            code: Response.data.content.data[0].kode_satker,
                            label: Response.data.content.data[0].nama_satker,
                            tag: Response.data.content.data[0].kode_satker,
                        };
                        this.selectedid_user = Response.data.content.data[0].kode_satker;
                    }
                    var tipe_work = Response.data.content.data[0].tipe_work;
                    if (tipe_work != '') {
                        this.defaultSelectedjenispekerjaan = {
                            code: Response.data.content.data[0].tipe_work,
                            label: Response.data.content.data[0].Kategori,
                            tag: Response.data.content.data[0].tipe_work,
                        };
                    }

                    this.defaultSelectedlokasi = {
                        code: Response.data.content.data[0].Lokasi,
                        label: Response.data.content.data[0].namalokasi,
                        tag: Response.data.content.data[0].Lokasi,
                    };

                    this.selectedlokasi = Response.data.content.data[0].Lokasi;

                    if (Response.data.content.data[0].Lokasi == '') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.selectedlokasi = '';
                    }

                    this.selectedjenispekerjaan = Response.data.content.data[0].tipe_work;
                    var registernya = Response.data.content.data[0].register;
                    this.arraynamaregister = [];
                    try {
                        var myArray = registernya.split(",");
                    } catch (error) {
                        var myArray = [];
                    }

                    //alert(myArray.length);

                    mainAPIDataSingelcari.get("parastapainnovation_koderegister-GetKodeRegister?random=" + random + "&project_id=" + this.project_id).then(
                        Response => {
                            this.datapesan = Response.data.message;
                            //alert(this.datapesan);
                            if (this.datapesan == 'data diketemukan') {
                                this.dataregister = [];
                                this.register = [];
                                this.dataregister = Response.data.content.data;
                                this.dataregister.forEach((item) => {
                                    for (let i = 0; i < myArray.length; i++) {
                                        if (item.kode_register == myArray[i]) {
                                            //this.arraynamaregister.push(item.kode_register_lengkap);
                                            this.arraynamaregister.push({
                                                label: item.kode_register_lengkap,
                                                code: this.dataregister.indexOf(item) + 1,
                                                tag: item.kode_register,
                                            });

                                            this.paramselectedregister.push(item.kode_register);
                                        }
                                    }
                                    if (item.kode_register == registernya) {
                                        this.defaultSelectedregister = {
                                            code: this.dataregister.indexOf(item) + 1,
                                            label: item.kode_register_lengkap,
                                            tag: item.kode_register,
                                        };
                                        this.selectedregister = item.kode_register;
                                    }
                                    this.register.push({
                                        label: item.kode_register_lengkap,
                                        code: this.dataregister.indexOf(item) + 1,
                                        tag: item.kode_register,
                                    });
                                });
                            }
                            this.halamanloading = false;
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });


                    document.getElementById('kode').value = Response.data.content.data[0].kode;
                    document.getElementById('urut').value = Response.data.content.data[0].urut;
                    document.getElementById('Nama_Kegiatan').value = Response.data.content.data[0].Nama_Kegiatan;
                    //this.Adendum = Response.data.content.data[0].ADENDUM;
                    this.kode = Response.data.content.data[0].kode;
                    this.urut = Response.data.content.data[0].urut;
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;
                    var Komponentemp = Response.data.content.data[0].Komponen;
                    var SubKomponentemp = Response.data.content.data[0].SubKomponen;

                    //alert(Komponentemp);

                    setTimeout(() => {
                        for (let i = 0; i < this.Komponen.length; i++) {
                            if (Komponentemp == this.Komponen[i].label) {
                                this.defaultSelectedKomponen = {
                                    code: this.Komponen[i].code,
                                    label: this.Komponen[i].label,
                                    tag: this.Komponen[i].tag,
                                };
                                this.selectedKomponenlabel = Komponentemp;
                            }
                        }

                        for (let i = 0; i < this.SubKomponen.length; i++) {
                            if (SubKomponentemp == this.SubKomponen[i].label) {
                                this.defaultSelectedSubKomponen = {
                                    code: this.SubKomponen[i].code,
                                    label: this.SubKomponen[i].label,
                                    tag: this.SubKomponen[i].tag,
                                };
                                this.selectedSubKomponenlabel = SubKomponentemp;
                            }
                        }
                    }, 500); // 2000 milliseconds = 2 seconds

                    this.tahapanpekerjaan = Response.data.content.data[0].datasocial;

                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        validasidata() {
            if (this.tahapanpekerjaan == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tahapan Social Safeguard..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            //alert(this.tahapanpekerjaan.length);
            var id_sosial = '';
            var isian = '';

            for (let z = 0; z < this.tahapanpekerjaan.length; z++) {
                if (this.tahapanpekerjaan[z].jenis != 'Folder') {
                    if (this.tahapanpekerjaan[z].jenis == 'Pilihan') {
                        if (z == 0) {
                            isian = isian + document.getElementById("select" + this.tahapanpekerjaan[z].id).value;
                            id_sosial = id_sosial + this.tahapanpekerjaan[z].id;
                        }
                        else {
                            isian = isian + "," + document.getElementById("select" + this.tahapanpekerjaan[z].id).value;
                            id_sosial = id_sosial + "," + this.tahapanpekerjaan[z].id;
                        }

                        //alert(document.getElementById("select" + this.tahapanpekerjaan[z].id).value);
                    }
                    else {
                        if (z == 0) {
                            isian = isian + document.getElementById(this.tahapanpekerjaan[z].jenis + this.tahapanpekerjaan[z].id).value;
                            id_sosial = id_sosial + this.tahapanpekerjaan[z].id;
                        }
                        else {
                            isian = isian + "," + document.getElementById(this.tahapanpekerjaan[z].jenis + this.tahapanpekerjaan[z].id).value;
                            id_sosial = id_sosial + "," + this.tahapanpekerjaan[z].id;
                        }
                        //alert(document.getElementById(this.tahapanpekerjaan[z].jenis + this.tahapanpekerjaan[z].id).value);
                    }
                }
            }

            id_sosial = id_sosial.slice(1);
            isian = isian.slice(1);
            //alert(id_sosial);
            //alert(isian);
            //return false;

            var fd = new FormData();
            fd.append("isian", isian);
            fd.append("id_sosial", id_sosial);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.secretencData);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_social-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Social");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.ambildatareff();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
    }
}
</script>
<style></style>